<template>
<div v-if="loaded">

  <!-- Coupon input overlay -->
  <div v-if="coupon_active" class="pay-coupon-overlay" @click.self="coupon_active = false">
    <div class="pay-coupon-dialog" role="dialog" aria-modal="true" aria-labelledby="coupon-title">
      <h3 id="coupon-title" class="pay-coupon-title">קופון</h3>
      <div
        v-if="couponError"
        class="pay-banner pay-banner--error"
        role="alert"
        aria-live="assertive"
      >{{ couponError }}</div>
      <div
        v-if="couponSuccess"
        class="pay-banner pay-banner--success"
        role="alert"
        aria-live="assertive"
      >{{ couponSuccess }}</div>
      <UiInput
        v-model="coupon"
        label="קוד קופון"
        placeholder="הזן את הקופון שלך"
        name="coupon"
        autocomplete="off"
        :error="couponError"
      />
      <div class="pay-coupon-actions">
        <UiButton variant="ghost" size="md" @click="coupon_active = false">בטל</UiButton>
        <UiButton variant="primary" size="md" @click="onConfirm()">שלח</UiButton>
      </div>
    </div>
  </div>

  <!-- Side premium panel -->
  <div id="side_primeum" v-if="side" dir="rtl">
    <button class="pay-close-btn" @click="$emit('close')" aria-label="סגור">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <h3 class="pay-heading">מנויי פרימיום <br>נהנים הרבה יותר!</h3>

    <ul class="pay-features">
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        גישה ללא הגבלה לספריית הסדרות והסרטים הנקיים הגדולה בעולם
      </li>
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        גישה חופשית לכל החוגים, הסדנאות והקורסים שלנו
      </li>
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        צפייה חופשית בתכנים המקוריים ובהפקות המקור
      </li>
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        כניסה חופשית להופעות בשידור חי ובהופעות חיות
      </li>
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        ללא תקופת התחייבות — אפשר לבטל תמיד
      </li>
      <li class="pay-feature-item">
        <span class="pay-feature-check" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        יצירת פרופילים אישיים לכל בני המשפחה
      </li>
    </ul>

    <p class="pay-price">49 ש"ח</p>

    <UiButton
      variant="primary"
      size="lg"
      :block="true"
      @click="showDialog = true"
    >
      שדרוג מנוי
    </UiButton>

    <button type="button" class="pay-coupon-link" @click="coupon_active = true">יש לך קופון?</button>
  </div>

  <!-- Payment dialog -->
  <div v-if="showDialog" class="pay-dialog-backdrop" @click.self="showDialog = false">
    <div class="pay-dialog" role="dialog" aria-modal="true" aria-label="תשלום">
      <button
        class="pay-dialog-close"
        @click="showDialog = false"
        aria-label="סגור חלון תשלום"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <iframe
        style="width:100%; height:450px; border:none;"
        allowtransparency="true"
        frameborder="0"
        scrolling="no"
        :src="'https://app.tov.tv/payments/do_redirect/' + payment_id"
        title="תשלום מנוי"
      ></iframe>
    </div>
  </div>

</div>
</template>

<script>
import UiButton from './ui/Button.vue';
import UiInput from './ui/Input.vue';

export default {
  components: { UiButton, UiInput },
  data() {
    return {
      payment_id: '',
      loaded: false,
      side: true,
      status: '',
      coupon: '',
      coupon_active: false,
      couponError: '',
      couponSuccess: '',
      showDialog: false,
    };
  },
  methods: {
    onConfirm() {
      this.couponError = '';
      this.couponSuccess = '';
      this.api_call({
        url: 'coupon_check',
        data: { coupon: this.coupon },
        onComplete: (data) => {
          this.status = data.data.data;
          if (this.status) {
            this.couponSuccess = 'הקופון התקבל בהצלחה!';
            setTimeout(() => {
              window.location.reload();
            }, 1200);
          } else {
            this.couponError = 'הקופון לא תקין — נא נסה שנית.';
          }
        },
      });
    },
  },
  created() {
    this.api_call({
      url: 'pay',
      onComplete: (data) => {
        this.payment_id = data.data.data;
        this.loaded = true;
      },
    });
  },
};
</script>

<style scoped lang="scss">
/* ── Side premium panel ── */
#side_primeum {
  position: fixed;
  inset-block: 0;
  inset-inline-start: 0;
  width: 25%;
  min-width: 480px;
  height: 100vh;
  background-color: var(--color-surface1);
  border-inline-end: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  padding: var(--space-8) var(--space-6);
  z-index: 999;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: var(--font-hebrew);
}

/* Mobile: full-screen panel */
@media (max-width: 768px) {
  #side_primeum {
    width: 100%;
    min-width: 0;
    padding: calc(env(safe-area-inset-top, 0px) + var(--space-6)) var(--space-4) calc(env(safe-area-inset-bottom, 0px) + var(--space-6));
    border-inline-end: none;
  }

  .pay-heading {
    font-size: 24px;
  }

  .pay-feature-item {
    font-size: 15px;
  }

  .pay-price {
    font-size: 28px;
  }
}

.pay-close-btn {
  position: absolute;
  inset-block-start: var(--space-6);
  inset-inline-end: var(--space-6);
  background: none;
  border: none;
  color: var(--color-text);
  cursor: pointer;
  padding: var(--space-2);
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
}

.pay-close-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.pay-heading {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-text);
  margin-block-end: var(--space-6);
  font-family: var(--font-hebrew);
}

/* ── Feature list ── */
.pay-features {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-6) 0;
  width: 100%;
}

.pay-feature-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding-block: var(--space-3);
  border-block-end: 1px solid var(--color-border);
  font-size: 17px;
  font-weight: 600;
  color: var(--color-textMuted);
  text-align: start;
  font-family: var(--font-hebrew);
  line-height: 1.45;
}

.pay-feature-item:last-child {
  border-block-end: none;
}

.pay-feature-check {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-accent);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  margin-block-start: 2px;
}

/* ── Price ── */
.pay-price {
  font-size: 32px;
  font-weight: 700;
  color: var(--color-text);
  margin-block-end: var(--space-4);
  font-family: var(--font-hebrew);
}

/* ── Coupon link ── */
.pay-coupon-link {
  background: none;
  border: none;
  font-size: 16px;
  color: var(--color-textMuted);
  cursor: pointer;
  margin-block-start: var(--space-4);
  font-family: var(--font-hebrew);
  padding: 4px 0;
  text-decoration: underline;
}

.pay-coupon-link:hover {
  color: var(--color-text);
}

.pay-coupon-link:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
  border-radius: 2px;
}

/* ── Payment dialog ── */
.pay-dialog-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

.pay-dialog {
  position: relative;
  background: var(--color-surface1);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 680px;
  padding-block-start: var(--space-8);
  overflow: hidden;
}

/* Mobile: full-height iframe, smaller padding */
@media (max-width: 768px) {
  .pay-dialog-backdrop {
    padding: var(--space-2);
    align-items: stretch;
  }

  .pay-dialog {
    border-radius: var(--radius-sm);
    padding-block-start: var(--space-6);
    display: flex;
    flex-direction: column;
    max-height: 90vh;
  }

  .pay-dialog iframe {
    height: calc(90vh - 80px) !important;
    min-height: 400px !important;
  }
}

.pay-dialog-close {
  position: absolute;
  inset-block-start: var(--space-3);
  inset-inline-end: var(--space-3);
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: var(--color-text);
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.pay-dialog-close:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* ── Coupon overlay ── */
.pay-coupon-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

.pay-coupon-dialog {
  background: var(--color-surface2);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  padding: var(--space-8) var(--space-6);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  font-family: var(--font-hebrew);
  direction: rtl;
}

.pay-coupon-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  font-family: var(--font-hebrew);
}

.pay-coupon-actions {
  display: flex;
  justify-content: flex-start;
  gap: var(--space-3);
}

/* ── Banners ── */
.pay-banner {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-sm);
  font-size: 15px;
  line-height: 1.5;
  font-family: var(--font-hebrew);
}

.pay-banner--error {
  background-color: rgba(224, 65, 65, 0.12);
  border: 1px solid rgba(224, 65, 65, 0.33);
  color: var(--color-danger);
}

.pay-banner--success {
  background-color: rgba(31, 174, 107, 0.12);
  border: 1px solid rgba(31, 174, 107, 0.33);
  color: var(--color-success);
}

/* ── Mobile ── */
@media only screen and (max-width: 600px) {
  #side_primeum {
    min-width: 0;
    width: 92%;
    padding: var(--space-6) var(--space-4);
  }

  .pay-feature-item {
    font-size: 14px;
  }

  .pay-feature-check {
    width: 26px;
    height: 26px;
    font-size: 14px;
  }

  .pay-dialog-backdrop {
    padding: 0;
  }

  .pay-dialog {
    border-radius: 0;
    max-width: 100%;
    min-height: 100vh;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pay-coupon-overlay,
  .pay-dialog-backdrop {
    transition: none;
  }
}
</style>
